// eslint-disable-next-line import/prefer-default-export
export const getDatesBetween = (startDate, endDate) => {
  const dates = [];
  const currentDate = new Date(startDate);
  while (currentDate <= endDate) {
    dates.push(new Date(currentDate));
    currentDate.setDate(currentDate.getDate() + 1);
  }
  return dates;
};

export const getDateXDaysAgo = (x) => new Date(new Date() - 1000 * 60 * 60 * 24 * x);
